import type { FC, ReactNode } from 'react'
import type { CategoryRef } from '@/types'

import Link from 'next/link'
import { cn } from '@/lib/utils'

interface CategoryLinkProps {
    category: CategoryRef
    className?: string
}

export const CategoryLink: FC<CategoryLinkProps> = ({ category, className }): ReactNode => {
    return (
        <Link
            href={`/topics/${category.slug}`}
            className={cn(
                'relative z-10 inline-flex w-fit text-xs font-semibold uppercase tracking-[0.16em] text-brand transition-colors hover:text-foreground focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring',
                className
            )}
        >
            {category.name}
        </Link>
    )
}
